<div cdkMenuBar>
  <div class="avatar-menu">
    <div>
      <ng-container *hasRole="roles">
        <div class="status-circle-box">
          @for (assignedCode of user.assignedCodes; track assignedCode) {
            <div
              class="circle"
              [ngStyle]="{ 'background-color': assignedCode | mapToColorClass }"
            ></div>
          }
        </div>
      </ng-container>
      <div class="d-flex flex-column gap-1">
        <span>{{ user.inAppName }}</span>
        <span style="opacity: 0.3; font-size: 10px">Version {{ version }}</span>
      </div>
    </div>
    <div style="position: relative">
      <ng-container *hasRole="roles">
        <div class="custum-status-box-icon">
          @if (checkedStatus() === "online") {
            <img
              height="12"
              src="assets/bootstrap_icons/check2.svg"
              width="12"
              alt="hero-img"
            />
          } @else {
            <div class="circle yellow"></div>
          }
        </div>
      </ng-container>
      @if (roleWithoutAvatar()) {
        <div
          class="insted-of-avatar main-avatar"
          cdkMenuItem
          [cdkMenuTriggerFor]="menu"
          [cdkMenuPosition]="menuPositions"
        >
          {{ getFirstLetters() }}
        </div>
      }

      @if (!roleWithoutAvatar()) {
        <img
          cdkMenuItem
          [cdkMenuTriggerFor]="menu"
          [cdkMenuPosition]="menuPositions"
          [src]="user.profilePicture | parseBase64"
          alt="mdo"
          height="55"
          style="cursor: pointer"
          width="55"
        />
      }
    </div>
  </div>

  <ng-template #menu>
    <div class="menu" cdkMenu>
      <div class="up-box">
        <div class="second-box">
          <div>
            @if (roleWithoutAvatar()) {
              <div class="insted-of-avatar">
                {{ getFirstLetters() }}
              </div>
            }
            @if (!roleWithoutAvatar()) {
              <img
                [src]="user.profilePicture | parseBase64"
                alt="mdo"
                height="62"
                width="62"
              />
            }
          </div>
          <div>
            <div>
              <p class="info-name name">{{ user.inAppName }}</p>
              <span></span>
            </div>
          </div>
          <ng-container *hasRole="roles">
            <div>
              <p class="info-name">
                {{ "front.profile_cabinet.emergency-code-team" | translate }}
              </p>
              <span class="status-circle-box">
                @for (assignedCode of user.assignedCodes; track assignedCode) {
                  <div
                    class="circle"
                    [ngStyle]="{
                      'background-color': assignedCode | mapToColorClass,
                    }"
                  ></div>
                }
              </span>
            </div>
          </ng-container>
        </div>
        <div (click)="handleLogOut()" class="log-out-box">
          <img
            alt="exit"
            height="25"
            src="assets/bootstrap_icons/box-arrow-in-left.svg"
            width="25"
          />
          <div class="log-out">
            {{ "front.profile_cabinet.log-out" | translate }}
          </div>
        </div>
      </div>
      <ng-container *hasRole="roles">
        <mat-divider></mat-divider>
        <div>
          <button [cdkMenuTriggerFor]="statusMenu" class="status-btn">
            <div
              [ngClass]="{
                green: checkedStatus() === 'online',
                yellow: checkedStatus() !== 'online',
              }"
              class="circle"
            ></div>
            <div>{{ checkedStatus() | titlecase }}</div>
            <app-icons-image name="keyboard_arrow_down"></app-icons-image>
          </button>
          <ng-template #statusMenu>
            <div cdkMenu>
              <div class="menu-status">
                <div class="status-menu">
                  <div
                    (click)="updateUserStatus('online')"
                    cdkMenuItem
                    class="break-info"
                  >
                    <div class="circle green"></div>
                    <div class="width">
                      <span>{{
                        "front.profile_cabinet.on-shift" | translate
                      }}</span>
                      <span>{{
                        "front.profile_cabinet.online" | translate
                      }}</span>
                    </div>
                    @if (checkedStatus() === "online") {
                      <app-icons-image name="check_primary"></app-icons-image>
                    } @else {
                      <span class="icon"></span>
                    }
                  </div>

                  @for (breakItem of staffBreaks(); track breakItem) {
                    <div
                      cdkMenuItem
                      class="break-info"
                      (click)="updateUserStatus(breakItem.label)"
                    >
                      <i
                        [ngClass]="{
                          'bi bi-clock': breakItem.time <= 29,
                          'bi bi-cup': breakItem.time > 29,
                        }"
                      ></i>
                      <div class="width">
                        <span>{{ breakItem.label }} </span>
                        <span>({{ breakItem.time }} minutes)</span>
                      </div>
                      @if (checkedStatus() === breakItem.label) {
                        <app-icons-image name="check_primary"></app-icons-image>
                      } @else {
                        <span class="icon"></span>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </ng-container>
    </div>
  </ng-template>
</div>
